import {ELEMENT} from './ElementTypes';

export type ElementLabel =
    | 'text'
    | 'textInput'
    | 'form'
    | 'table'
    | 'button'
    | 'image'
    | 'video'
    | 'question'
    | 'yesNoQuestion'
    | 'multiselect'
    | 'photoQuestion'
    | 'imageMarkup'
    | 'sequenceQuestionElement'
    | 'matchPairs'
    | 'likertScale'
    | 'report'
    | 'ellipse'
    | 'square'
    | 'triangle'
    | 'star'
    | 'line'
    | 'arrow'
    | 'html'
    | 'modal'
    | 'imageGallery'
    | 'flipCard'
    | 'calculator.calculator'
    | 'chatbot.chatbot';

type ElementData = {
    type: ELEMENT;
    label: ElementLabel;
    icon: string;
    elementProps?: Record<string, unknown>;
    shortcut?: string[];
};

export const ELEMENTS: ElementData[] = [
    {type: ELEMENT.STATIC_TEXT, label: 'text', icon: 'solar:text-linear', shortcut: ['t']},
    {type: ELEMENT.TEXT_INPUT, label: 'textInput', icon: 'solar:text-field-linear'},
    {type: ELEMENT.FORM, label: 'form', icon: 'solar:clipboard-list-linear'},
    {
        type: ELEMENT.STATIC_TABLE_V2,
        label: 'table',
        icon: 'solar:widget-4-outline',
        shortcut: ['shift+t'],
    },
    {type: ELEMENT.BUTTON, label: 'button', icon: 'solar:cursor-linear'},
    {type: ELEMENT.IMAGE, label: 'image', icon: 'solar:gallery-linear'},
    {type: ELEMENT.VIDEO, label: 'video', icon: 'solar:video-frame-play-horizontal-linear'},

    {
        type: ELEMENT.QUESTION,
        label: 'question',
        icon: 'solar:question-square-linear',
        elementProps: {answerNum: 2},
        shortcut: ['shift+q'],
    },
    {type: ELEMENT.YES_NO_QUESTION_V2, label: 'yesNoQuestion', icon: 'ph:scales', shortcut: ['shift+n']},
    {
        type: ELEMENT.MULTI_SELECT,
        label: 'multiselect',
        icon: 'solar:checklist-minimalistic-linear',
        elementProps: {answerNum: 2},
        shortcut: ['shift+m'],
    },
    {
        type: ELEMENT.PHOTO_ANSWER_QUESTION,
        label: 'photoQuestion',
        icon: 'solar:gallery-check-linear',
        shortcut: ['shift+p'],
        elementProps: {answerNum: 2},
    },
    {type: ELEMENT.IMAGE_MARKUP, label: 'imageMarkup', icon: 'ph:map-pin-simple-area-duotone', shortcut: ['shift+i']},
    {
        type: ELEMENT.SEQUENCE_QUESTION,
        label: 'sequenceQuestionElement',
        icon: 'solar:sort-from-top-to-bottom-linear',
        shortcut: ['shift+s'],
    },
    {type: ELEMENT.MATCH_PAIR_QUESTION, label: 'matchPairs', icon: 'solar:widget-2-linear', shortcut: ['shift+x']},
    {type: ELEMENT.LIKERT_SCALE, label: 'likertScale', icon: 'solar:check-circle-linear', shortcut: ['shift+l']},
    {type: ELEMENT.QUESTION_REPORT, label: 'report', icon: 'solar:chart-square-linear'},

    {type: ELEMENT.ELLIPSE, label: 'ellipse', icon: 'fluent-mdl2:ellipse'},
    {type: ELEMENT.RECTANGLE, label: 'square', icon: 'solar:stop-linear'},
    {type: ELEMENT.TRIANGLE, label: 'triangle', icon: 'ph:triangle'},
    {type: ELEMENT.STAR, label: 'star', icon: 'solar:star-linear'},
    {type: ELEMENT.LINE_V2, label: 'line', icon: 'ph:line-segment-duotone', shortcut: ['l']},
    {type: ELEMENT.ARROW_V2, label: 'arrow', icon: 'solar:arrow-right-up-linear', shortcut: ['shift+a']},

    {type: ELEMENT.HTML, label: 'html', icon: 'solar:code-linear'},
    {type: ELEMENT.MODAL, label: 'modal', icon: 'solar:notification-unread-linear'},
    {type: ELEMENT.IMAGE_GALLERY, label: 'imageGallery', icon: 'solar:album-linear'},
    {type: ELEMENT.FLIP_CARD, label: 'flipCard', icon: 'solar:flip-horizontal-linear'},
    {type: ELEMENT.CALCULATOR, label: 'calculator.calculator', icon: 'solar:calculator-linear'},
    {type: ELEMENT.CHATBOT, label: 'chatbot.chatbot', icon: 'solar:chat-dots-outline'},
];

export const getElementsData = (types: ELEMENT[]): ElementData[] => types.map((type) => getElementData(type) as ElementData);

export const getElementData = (type: ELEMENT): ElementData | undefined => ELEMENTS.find((element) => element.type === type);
